import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import BlockUi from 'react-block-ui'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import PaymentList from '../list/PaymentList'
import withLayout from '../../../layout/withLayout'

const style = {
    width: '100%',
    height: '200px',
    borderWidth: '2px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
    padding: '35px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '32px',
}

const CSVUpload = ({uploadDBCSV, uploadPostFinanceCSV, uploadZABCSV, uploadTabeoCSV, uploadSplitItCSV, paymentList, fetching}) => {
    return (
        <BlockUi tag="div" blocking={fetching}>
            <ContentBox title="Upload Deutsche Bank CSV">
                <Row>
                    <Column>
                        <Dropzone
                            multiple={false}
                            style={style}
                            disablePreview={true}
                            onDrop={(fileList) => {
                                uploadDBCSV(fileList[0])
                            }}>
                            <p>Click to upload CSV</p>
                        </Dropzone>
                    </Column>
                </Row>
            </ContentBox>
            <ContentBox title="Upload PostFinance AG Bank CSV (CH)">
                <Row>
                    <Column>
                        <Dropzone
                            multiple={false}
                            style={style}
                            disablePreview={true}
                            onDrop={(fileList) => {
                                uploadPostFinanceCSV(fileList[0])
                            }}>
                            <p>Click to upload CSV</p>
                        </Dropzone>
                    </Column>
                </Row>
            </ContentBox>
            <ContentBox title="Upload ZAB CSV">
                <Row>
                    <Column>
                        <Dropzone
                            multiple={false}
                            style={style}
                            disablePreview={true}
                            onDrop={(fileList) => {
                                uploadZABCSV(fileList[0])
                            }}>
                            <p>Click to upload CSV</p>
                        </Dropzone>
                    </Column>
                </Row>
            </ContentBox>
            <ContentBox title="Upload Tabeo CSV">
                <Row>
                    <Column>
                        <Dropzone
                            multiple={false}
                            style={style}
                            disablePreview={true}
                            onDrop={(fileList) => {
                                uploadTabeoCSV(fileList[0])
                            }}>
                            <p>Click to upload CSV</p>
                        </Dropzone>
                    </Column>
                </Row>
            </ContentBox>
            <ContentBox title="Upload SplitIt CSV">
                <Row>
                    <Column>
                        <Dropzone
                            multiple={false}
                            style={style}
                            disablePreview={true}
                            onDrop={(fileList) => {
                                uploadSplitItCSV(fileList[0])
                            }}>
                            <p>Click to upload CSV</p>
                        </Dropzone>
                    </Column>
                </Row>
            </ContentBox>
            {paymentList.length !== 0 && (<PaymentList skipAuthorization={true} paymentList={paymentList}/>)}
        </BlockUi>
    )
}

CSVUpload.propTypes = {
    uploadDBCSV: PropTypes.func.isRequired,
    uploadPostFinanceCSV: PropTypes.func.isRequired,
    uploadZABCSV: PropTypes.func.isRequired,
    uploadTabeoCSV: PropTypes.func.isRequired,
    uploadSplitItCSV: PropTypes.func.isRequired,
    paymentList: PropTypes.array.isRequired,
    fetching: PropTypes.bool.isRequired,
}

export default withLayout(CSVUpload)



// WEBPACK FOOTER //
// ./src/modules/payment/component/upload/CSVUpload.js